import { createSlice } from "@reduxjs/toolkit";
// import jwt_decode from "jwt-decode";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    isAuthenticated: false,
    user: {
      email: "",
      name: "",
      picture: "",
      isAdmin: false,
    },
  },
  reducers: {
    setCredentials: (state, action) => {
      const { email, isAdmin, token, name } = action.payload;

      state.user.email = email;
      state.user.isAdmin = isAdmin;
      state.user.name = name;
      state.token = token;
      state.isAuthenticated = true;
    },
    logOut: (state) => {
      state.token = "";
      state.isAuthenticated = false;
      state.roles = [];
      state.user = {};
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const isAuthenticated = (state) => state.isAuthenticated;
export const selectCurrentToken = (state) => state.auth.token;
